export default __webpack_public_path__ + "static/media/les_deeptech.f2b2a306.png";